import { TabPanel } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { useState } from 'react';
import BoilPressBlocks from './BoilPressBlocks';
import SiteInformation from './SiteInformation';

const Dashboard = () => {
	const [ activeTab, setActiveTab ] = useState( 'site-information' );

	const onSelect = ( tab ) => {
		setActiveTab( tab );
	};

	const pages = {
		'site-information': <SiteInformation />,
		'boilpress-blocks': <BoilPressBlocks />,
	};

	return (
		<div>
			<h1>{ __( 'Dashboard', 'boilpress' ) }</h1>
			<TabPanel
				className="boilpress-dashboard-tabs"
				activeClass="active-tab"
				onSelect={ onSelect }
				tabs={ [
					{
						name: 'site-information',
						title: __( 'Site Information', 'boilpress' ),
					},
					{
						name: 'boilpress-blocks',
						title: __( 'BoilPress Blocks', 'boilpress' ),
					},
				] }
			>
				{ ( tab ) =>
					pages[ tab.name ] || (
						<div>{ __( 'No content available', 'boilpress' ) }</div>
					)
				}
			</TabPanel>
		</div>
	);
};

export default Dashboard;
